module.exports = __webpack_public_path__ + "static/media/kc-chng-200x200.f1f60f9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/kc-chng-200x200.jpg
// module id = 1782
// module chunks = 147